import axios from "axios";
import { useEffect, useState } from "react";
import InlineTabularForm from "./common/inline-tabular-form/inlineTabularForm";
import qs from "qs";
import dataProvider from "../../../../../services/dataProvider";
import authServices from "../../../../../services/authServices";
import AssociatedTask from "../../../common/associated-task";
import getAssociatedTask from "../getAssociatedTask";
import { markTaskComplete } from "../../../common/mark-task-complete";

const InlineForm = ({ schema, formType, formTitle }) => {
    const [inlineFormState, setInlineFormState] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [isUpdating, setIsUpdating] = useState(false);
    const [associatedTask, setAssociatedTask] = useState(null);
    const [completeTask, setCompleteTask] = useState(true);

    function cleanupData(data) {
        let cleanDataList = [];
        data.forEach((row) => {
            let cleanRow = {};
            Object.keys(schema).forEach((field) => {
                cleanRow[field] = row[field];
            });
            cleanRow.id = row.id;
            cleanDataList.push(cleanRow);
        });

        return cleanDataList;
    }

    useEffect(() => {
        setIsFetching(true);
        var data = qs.stringify({
            formType,
            isInline: true,
        });

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-getInlineFormsByFormType",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.status === "success") {
                    getAssociatedTask(formType)
                        .then(function (res) {
                            setIsFetching(false);
                            // console.log("AT",res.data);
                            if (res.data.length > 0) {
                                setAssociatedTask(res.data[0]);
                                // console.log(res.data[0]);
                            }
                        })
                        .catch(function (error) {
                            setIsFetching(false);
                            console.error(error);
                        });

                    let cleanData = cleanupData(response.data.data);
                    setInlineFormState(cleanData);
                } else {
                    setIsFetching(false);
                }
            })
            .catch(function (error) {
                setIsFetching(false);
                setErrorMsg(error.message);
                console.error(error);
            });
    }, []);

    function onSubmit(formState) {
        var FormData = require("form-data");
        var data = new FormData();

        setIsUpdating(true);
        setSuccessMsg("");
        setErrorMsg("");

        data.append("formType", formType);
        data.append("formTitle", formTitle);

        for (var key in formState) {
            data.append(key, formState[key]);
        }

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-addInlineFormDetails",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.status === "success") {
                    if (completeTask && associatedTask) {
                        markTaskComplete(associatedTask.id)
                            .then(function (response) {
                                // console.log(JSON.stringify(response.data));
                                // setIsUpdating(false);
                                // setSuccessMsg("New Entry Recorded");
                                window.location.reload();
                            })
                            .catch(function (error) {
                                console.error(error);
                                setIsUpdating(false);
                                setSuccessMsg("");
                                setErrorMsg("Unable To Complete Task")
                            });
                    } else {
                        setIsUpdating(false);
                        setSuccessMsg("New Entry Recorded");
                    }
                    
                    setInlineFormState(response.data.data);
                } else {
                    setIsUpdating(false);
                    setErrorMsg("Something Went Wrong");
                }
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsUpdating(false);
            });
    }

    function onUpdate(formState) {
        var FormData = require("form-data");
        var data = new FormData();

        setIsUpdating(true);
        setSuccessMsg("");
        setErrorMsg("");

        data.append("editFormId", formState.id);
        data.append("formType", formType);
        data.append("formTitle", formTitle);

        for (var key in formState) {
            data.append(key, formState[key]);
        }

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-editInlineFormById",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.status === "success") {
                    setSuccessMsg("Entry Updated");
                    setInlineFormState(response.data.data || []);
                } else {
                    setErrorMsg("Something Went Wrong");
                }
                setIsUpdating(false);
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsUpdating(false);
            });
    }

    function onDelete(row) {
        setIsUpdating(true);
        setSuccessMsg("");
        setErrorMsg("");

        var data = qs.stringify({
            formType,
            deleteFormId: row.id,
        });

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-deleteInlineFormByDocId",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setIsUpdating(false);
                if (response.data.status === "success") {
                    setSuccessMsg("Entry Deleted");
                    setInlineFormState(response.data.data || []);
                } else {
                    setErrorMsg("Something Went Wrong");
                }
            })
            .catch(function (error) {
                setIsUpdating(false);
                console.error(error);
                setErrorMsg(error.message);
            });
    }

    function onFileView(fileName) {
        var data = qs.stringify({
            filePath: fileName,
        });

        setIsUpdating(true);
        setErrorMsg("");

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "getFileUrlFromFilePath",
            headers: {
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setIsUpdating(false);
                //console.log("FILE URL FETCH", response);
                window.open(response.data.data[0], "_blank").focus();
            })
            .catch(function (error) {
                setIsUpdating(false);
                console.error("File Fetch", error);
                setErrorMsg(error.message);
            });
    }

    return (
        <div id="SGMonthlyChecklistLicenseeForm">
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom">
                    <h5 className="m-0">{formTitle}</h5>
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {associatedTask && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <AssociatedTask
                        style={{ marginBottom: 0 }}
                        task={associatedTask}
                        completeTask={completeTask}
                        setCompleteTask={setCompleteTask}
                    />
                </div>
            )}

            {isFetching ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Form Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="d-flex justify-content-center">
                            <div className="w-100">
                                <div className="w-100">
                                    <InlineTabularForm
                                        isUpdating={isUpdating}
                                        onSubmit={onSubmit}
                                        onUpdate={onUpdate}
                                        onDelete={onDelete}
                                        onFileView={onFileView}
                                        data={inlineFormState}
                                        schema={schema}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InlineForm;
